import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47cbc1ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "interviewQuestionDetailPage" }
const _hoisted_2 = { class: "interviewQuestionList" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin":"0 auto 10px"} }, "已收藏题目列表", -1))
const _hoisted_4 = { style: {"margin":"0 20px"} }
const _hoisted_5 = { class: "interviewQuestionDetail" }
const _hoisted_6 = { class: "questionCart" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  class: "context",
  style: {"margin-top":"20px"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  class: "next",
  style: {"margin-top":"20px"}
}
const _hoisted_14 = { class: "comment" }

import API from "@/api";
import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import {
  doInterviewQuestionFavourUsingPost,
  doInterviewQuestionThumbUsingPost,
  getInterviewQuestionVoByIdUsingGet,
  listMyInterviewQuestionFavourPostByPageUsingPost,
} from "@/request/api/interviewQuestionController";
import ShareTrigger from "@/components/trigger/ShareTrigger.vue";
import CommentCart from "@/components/list/CommentCart.vue";
import MdViewer from "@/components/md/MdViewer.vue";

//查询参数

export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewQuestionListMyFavourPage',
  setup(__props) {

const searchParams = ref<API.InterviewQuestionQueryRequest>({
  current: 1,
  pageSize: 20,
});

const questionId = ref<number>(0);
const no = ref<number>(1);
const data = ref<API.InterviewQuestionVO>({
  title: "请选择题目",
  answer: "请选择题目",
});
const dataList = ref<API.InterviewQuestionVO[]>([]);
//搜索关键词
const searchText = ref<string>("");
const like = ref(false);
const star = ref(false);
const questionLoading = ref<boolean>(false);
/**
 * 搜索
 */
const search = async () => {
  const res = await listMyInterviewQuestionFavourPostByPageUsingPost({
    searchText: searchText.value,
    ...searchParams.value,
  });
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    questionId.value = dataList.value[0]?.id as number;
  } else {
    message.error("加载数据失败，" + res.data.message);
  }
};
/**
 * 加载数据
 */
const loadData = async () => {
  if (!questionId.value || questionId.value <= 0) {
    return;
  }
  questionLoading.value = true;
  const response = await getInterviewQuestionVoByIdUsingGet({
    id: questionId.value,
  });

  if (response.data.code === 0 && response.data.data) {
    data.value = response.data.data;
    like.value = data.value.isThumb;
    star.value = data.value.isFavour;
  } else {
    message.error("加载题目数据失败，" + response.data.message);
    message.error("请重新选择题目");
  }
  questionLoading.value = false;
};
/**
 * 加载左侧列表数据
 */
const loadListData = async () => {
  const response = await listMyInterviewQuestionFavourPostByPageUsingPost(
    searchParams.value
  );
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    questionId.value = dataList.value[0]?.id as number;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};

/**
 * 点击菜单项
 * @param id
 */
const onClickMenuItem = (id: number) => {
  if (questionId.value == id) return;
  questionId.value = id;
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

onMounted(() => {
  loadListData();
});

/**
 * 点赞
 */
const onLikeChange = () => {
  if (data.value) {
    return;
  }
  if (like.value) {
    data.value.thumbNum--;
  } else {
    data.value.thumbNum++;
  }
  like.value = !like.value;
  doInterviewQuestionThumbUsingPost({
    bizId: questionId.value,
    bizType: "InterviewQuestion",
  });
};

/**
 * 收藏
 */
const onStarChange = () => {
  if (data.value) {
    return;
  }
  if (star.value) {
    data.value.favourNum--;
  } else {
    data.value.favourNum++;
  }
  star.value = !star.value;
  doInterviewQuestionFavourUsingPost({
    bizId: questionId.value,
    bizType: "InterviewQuestion",
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_IconEye = _resolveComponent("IconEye")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconStarFill = _resolveComponent("IconStarFill")!
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_IconEyeInvisible = _resolveComponent("IconEyeInvisible")!
  const _component_icon_eye_invisible = _resolveComponent("icon-eye-invisible")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { class: "all" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: "4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_menu, {
                modelValue: dataList.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataList).value = $event)),
                "selected-keys": questionId.value
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_a_input_search, {
                    placeholder: "搜索题目...",
                    modelValue: searchText.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                    onChange: search,
                    "allow-clear": "",
                    style: {"margin-bottom":"10px"}
                  }, null, 8, ["modelValue"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (data, index) => {
                    return (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: data.id,
                      onClick: ($event: any) => (onClickMenuItem(data.id))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1) + ". " + _toDisplayString(data.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128)),
                  (dataList.value.length === 0)
                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: 0,
                        disabled: "",
                        style: {"text-align":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 暂无收藏题目 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "selected-keys"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: "14" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_layout_content, {
                "hide-trigger": "",
                collapsible: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_spin, {
                    loading: questionLoading.value,
                    tip: "题目正在加载",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_form_item, { style: {"padding":"0px 20px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_typography_title, {
                              heading: 2,
                              bold: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(data.value.title), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (data.value.content)
                          ? (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 0,
                              style: {"padding":"0px 20px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_typography_text, { style: {"margin-top":"-20px","padding-right":"40px"} }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(data.value.content), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_form_item, { style: {"padding":"0px 20px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.tagList, (tag) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, { key: tag }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_divider),
                        _createVNode(_component_a_row, {
                          style: {"font-size":"15px","padding-bottom":"10px"},
                          justify: "space-between"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              span: 2,
                              style: {"margin":"0 auto"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { class: "action" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_IconEye),
                                    _createVNode(_component_a_typography_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.value.viewNum), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              span: 2,
                              style: {"margin":"0 auto"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, {
                                  onClick: onLikeChange,
                                  class: "action"
                                }, {
                                  default: _withCtx(() => [
                                    (like.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                          _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                          _createVNode(_component_IconHeart)
                                        ])),
                                    _createVNode(_component_a_typography_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.value.thumbNum), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              span: 2,
                              style: {"margin":"0 auto"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, {
                                  onClick: onStarChange,
                                  class: "action"
                                }, {
                                  default: _withCtx(() => [
                                    (star.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                          _createVNode(_component_IconStarFill, { style: {"color":"#fff35d"} })
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                          _createVNode(_component_IconStar)
                                        ])),
                                    _createVNode(_component_a_typography_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.value.favourNum), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              span: 2,
                              style: {"margin":"0 auto"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_space, { class: "action" }, {
                                  default: _withCtx(() => [
                                    _createVNode(ShareTrigger, {
                                      "share-link": 'interviewQuestion/detail/' + data.value.id
                                    }, null, 8, ["share-link"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_tabs, {
                      size: "large",
                      centered: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, { key: "1" }, {
                          title: _withCtx(() => [
                            _createVNode(_component_IconEye),
                            _createTextVNode(" 查看答案 ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_spin, {
                              loading: questionLoading.value,
                              tip: "答案正在加载",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(MdViewer, {
                                  value: data.value.answer
                                }, null, 8, ["value"]),
                                (data.value.answer === '该面试题需要VIP才能查看答案')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      _createVNode(_component_a_button, {
                                        shape: "round",
                                        size: "large",
                                        type: "primary",
                                        status: "warning",
                                        style: {"width":"100px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("开通VIP ")
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, { key: "2" }, {
                          title: _withCtx(() => [
                            _createVNode(_component_IconEyeInvisible),
                            _createTextVNode(" 隐藏答案 ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_empty, null, {
                              image: _withCtx(() => [
                                _createVNode(_component_icon_eye_invisible)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" 答案已隐藏 ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          flex: "50px",
                          style: {"margin":"0 auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_link, null, {
                              default: _withCtx(() => [
                                _createTextVNode("上一题")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { flex: "auto" }),
                        _createVNode(_component_a_col, {
                          flex: "50px",
                          style: {"margin":"0 auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_link, null, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(CommentCart, {
                      "biz-id": questionId.value,
                      "biz-type": "InterviewQuestion"
                    }, null, 8, ["biz-id"])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})